import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { ItemEditorPicker as CodeListEditorPicker } from '@/components/codeLists/itemEditorPicker'
import { ValidationBoundary, ValidationState } from '@/components/validation'
import context from '@/context'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs/index'
import { connect } from 'react-redux'

const mapDispatchToProps = {
  openDialog: dialogActions.openDialog
}

@connect(null, mapDispatchToProps)
class CodeListEditorDialog extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: this.props.content.item
    }
  }

  handleConfirm = () => {
    const { value } = this.state
    if (!value) {
      return false
    }

    context.api.codeListService.existCode(value.id || 0, value.code, this.props.content.itemType)
      .then(() => this.props.onAction(value))
      .catch(error => this.props.openDialog({
        dialogType: dialogTypes.alert,
        title: 'Common.Error',
        content: (error.response && error.response.data && error.response.data.error && error.response.data.error.message) ||
          'Common.ServerInternalError'
      }))
  }

  handleChange = value => {
    this.setState({ value })
  }

  render () {
    const props = this.props
    return (
      <ValidationBoundary>
        <BasicHeader title='' {...props} />
        <ModalBody>
          <CodeListEditorPicker {...props.content} disabled={this.props.disabled} onChange={x => this.handleChange(x)} />
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter icon='save' {...props} onAction={() => this.handleConfirm()} disabled={!isValid || this.props.disabled} />
        } />
      </ValidationBoundary>
    )
  }
}

export default {
  component: CodeListEditorDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/codeListEditor.js